import script from "./SettingsItemImportance.vue?vue&type=script&setup=true&lang=js"
export * from "./SettingsItemImportance.vue?vue&type=script&setup=true&lang=js"

import "./SettingsItemImportance.vue?vue&type=style&index=0&id=28c4974b&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-28c4974b"]])

export default __exports__